import React, { memo, useCallback } from 'react';
import { connect } from 'react-redux';
import { authSelectors, actions as authActions } from '@ui/store/auth';
import { StoreState } from '@ui/store/rootReducer';
import { Link } from 'react-router-dom';
import { UserRoleEnum } from '@ui/api/v2/user.api';

import { getLogoName } from '../../../utils/config';

import './Header.less';
import { useRouter } from '../../../hooks/useRouter';

interface StateToProps {
  role: UserRoleEnum;
}

interface DispatchToProps {
  onLogout: () => void;
}

type Props = StateToProps & DispatchToProps;

function HeaderLinks({ role }: { role: UserRoleEnum }) {
  const { location } = useRouter();

  const isSelected = useCallback(
    (pathname: string) => {
      return location.pathname.includes(pathname);
    },
    [location.pathname],
  );

  if (role === UserRoleEnum.ContentManager) {
    return (
      <div className="header__nav-menu__group">
        <Link
          className={`header__nav-menu__item-link ${isSelected('report') && 'header__nav-menu__item-link--button'}`}
          to="/report"
        >
          Отчет
        </Link>
        <Link
          className={`header__nav-menu__item-link ${isSelected('cities') && 'header__nav-menu__item-link--button'}`}
          to="/cities"
        >
          Города
        </Link>
        <Link
          className={`header__nav-menu__item-link ${isSelected('regions') && 'header__nav-menu__item-link--button'}`}
          to="/regions"
        >
          Области
        </Link>
        <Link
          className={`header__nav-menu__item-link ${isSelected('factories') && 'header__nav-menu__item-link--button'}`}
          to="/factories"
        >
          Фабрики
        </Link>
        <Link
          className={`header__nav-menu__item-link ${isSelected('managers') && 'header__nav-menu__item-link--button'}`}
          to="/managers"
        >
          Менеджеры
        </Link>
        <Link
          className={`header__nav-menu__item-link ${isSelected('collections') &&
            'header__nav-menu__item-link--button'}`}
          to="/collections"
        >
          Коллекции
        </Link>
        <Link
          className={`header__nav-menu__item-link ${isSelected('markets') && 'header__nav-menu__item-link--button'}`}
          to="/markets"
        >
          ТЦ
        </Link>
        <Link
          className={`header__nav-menu__item-link ${isSelected('requests') && 'header__nav-menu__item-link--button'}`}
          to="/requests"
        >
          Запросы
        </Link>
        <Link
          className={`header__nav-menu__item-link ${isSelected('countries') && 'header__nav-menu__item-link--button'}`}
          to="/countries"
        >
          Магазины
        </Link>
      </div>
    );
  }

  if (role === UserRoleEnum.Manager) {
    return (
      <div className="header__nav-menu__group">
        <Link
          className={`header__nav-menu__item-link ${isSelected('requests') && 'header__nav-menu__item-link--button'}`}
          to="/requests"
        >
          Запросы
        </Link>
        <Link
          className={`header__nav-menu__item-link ${isSelected('regions') && 'header__nav-menu__item-link--button'}`}
          to="/regions"
        >
          Магазины
        </Link>
      </div>
    );
  }

  if (role === UserRoleEnum.Admin) {
    return (
      <div className="header__nav-menu__group">
        <Link
          className={`header__nav-menu__item-link ${isSelected('admin/managers') &&
            'header__nav-menu__item-link--button'}`}
          to="/admin/managers"
        >
          Менеджеры
        </Link>
        <Link
          className={`header__nav-menu__item-link ${isSelected('admin/soap') && 'header__nav-menu__item-link--button'}`}
          to="/admin/soap"
        >
          SOAP
        </Link>
      </div>
    );
  }

  return null;
}

function Header({ onLogout, role }: Props) {
  const logoName = getLogoName();
  const logoSvg = require(`../../../assets/${logoName}`);

  return (
    <header className="header">
      <div className="header__container">
        <div className="header__logo">
          <span>
            <img src={logoSvg} alt="Logo" />
          </span>
        </div>
        <div className="header__nav-menu">
          <HeaderLinks role={role} />
          <div className="header__nav-menu__item">
            <a onClick={onLogout}>Выйти</a>
          </div>
        </div>
      </div>
    </header>
  );
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  role: authSelectors.getUserRole(state),
});

const mapDispatchToProps = {
  onLogout: authActions.logoutRequested,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Header));



// WEBPACK FOOTER //
// ./src/scenes/Header/containers/Header.tsx